import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper";
import { Avatar, Paper, Typography, useMediaQuery } from "@mui/material";
// import Avatar, { ConfigProvider } from "react-avatar";
import { Container } from "react-bootstrap";
import * as constants from "../../../Components/constants";
import AOS from "aos";
import "aos/dist/aos.css";
import Link from "next/link";

const baseURL = constants.BASE_URL;

const PRTPStudent = ({ isLoggedIn }) => {
  const [enrolledStudents, setEnrolledStudents] = React.useState([]);

  React.useEffect(() => {
    AOS.init();
  }, []);

  //   Getting Enrolled Students
  React.useEffect(() => {
    fetch(`${baseURL}/course/4/enrollment/payment-all`)
      .then((res) => res.json())
      .then((data) => {
        setEnrolledStudents(data);
      });
  }, []);

  const matches = useMediaQuery("(max-width:768px)");

  return (
    <Container className="my-4">
      {enrolledStudents.length !== 0 && (
        <Typography
          align="center"
          className="py-3"
          fontWeight={600}
          variant={matches ? "h5" : "h4"}
          gutterBottom
        >
          Course Students
        </Typography>
      )}
      <Swiper
        slidesPerGroup={1}
        breakpoints={{
          320: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 0,
          },
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        modules={[Autoplay]}
        className="mySwiper"
      >
        {enrolledStudents.length !== 0 &&
          enrolledStudents.map((st, idx) => (
            <SwiperSlide
              key={idx}
              className="d-flex align-items-center justify-content-center p-3"
            >
              {isLoggedIn ? (
                <Link href={`/user/${st.student}`}>
                  <Paper
                    sx={{ width: "15rem", height: "16rem", cursor: "pointer" }}
                    elevation={4}
                    className="mb-2 p-3 d-flex flex-column align-items-center rounded-3"
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                  >
                    <Avatar
                      alt={st.student_first_name}
                      src={st.student_profile_pic}
                      sx={{ width: 100, height: 100 }}
                    />

                    <Typography
                      align="center"
                      fontWeight={600}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {st?.student_first_name}
                    </Typography>

                    <Typography align="center" variant="subtitle2" gutterBottom>
                      {st?.student_profession}
                    </Typography>

                    <Typography align="center" variant="subtitle2" gutterBottom>
                      {st?.student_academic_discipline}
                    </Typography>

                    <span
                      className="text-center d-inline-block text-truncate"
                      style={{ maxWidth: "120px" }}
                    >
                      {st?.student_organization}
                    </span>
                  </Paper>
                </Link>
              ) : (
                <Paper
                  sx={{ width: "15rem", height: "16rem", cursor: "pointer" }}
                  elevation={4}
                  className="mb-2 p-3 d-flex flex-column align-items-center rounded-3"
                  data-aos="fade-up"
                  data-aos-anchor-placement="top-bottom"
                >
                  <Avatar
                    alt={st.student_first_name}
                    src={st.student_profile_pic}
                    sx={{ width: 100, height: 100 }}
                  />

                  <Typography
                    align="center"
                    fontWeight={600}
                    variant="subtitle2"
                    gutterBottom
                  >
                    {st?.student_first_name}
                  </Typography>

                  <Typography align="center" variant="subtitle2" gutterBottom>
                    {st?.student_profession}
                  </Typography>

                  <Typography align="center" variant="subtitle2" gutterBottom>
                    {st?.student_academic_discipline}
                  </Typography>

                  <span
                    className="text-center d-inline-block text-truncate"
                    style={{ maxWidth: "120px" }}
                  >
                    {st?.student_organization}
                  </span>
                </Paper>
              )}
            </SwiperSlide>
          ))}
      </Swiper>
    </Container>
  );
};

export default PRTPStudent;
